module.exports = __webpack_public_path__ + "img/d.fb0a4e90.png";